<section
  class="bg-elevated border-default flex w-64 flex-col gap-2 rounded-md border p-3 shadow-md"
  [attr.aria-label]="
    session.label()
      ? ('common.editing_name' | translate: { name: session.label() })
      : ('features.entities.geo_arc.session.title_new' | translate)
  ">
  <header class="flex items-center gap-1.5">
    <i [class]="ICONS.path" class="text-accent-main text-base"></i>
    <h4 class="text-text-primary truncate text-[13px] font-semibold">
      @if (session.label(); as name) {
        {{ 'common.editing_name' | translate: { name } }}
      } @else {
        {{ 'features.entities.geo_arc.session.title_new' | translate }}
      }
    </h4>
  </header>

  <p class="text-text-secondary text-xs leading-snug">
    {{ 'features.entities.geo_arc.session.hint' | translate }}
  </p>

  @if (session.isComputing()) {
    <p class="text-text-tertiary font-mono text-xs">
      {{ 'features.entities.geo_arc.session.computing' | translate }}
    </p>
  } @else if (session.notice() === 'provider-failed') {
    <p class="flex items-start gap-1.5 text-xs text-orange-600 dark:text-orange-400">
      <i [class]="ICONS.warning" class="mt-px"></i>
      <span>{{ 'features.entities.geo_arc.session.provider_failed' | translate }}</span>
    </p>
  } @else if (session.notice() === 'too-many-vias') {
    <p class="flex items-start gap-1.5 text-xs text-orange-600 dark:text-orange-400">
      <i [class]="ICONS.warning" class="mt-px"></i>
      <span>{{ 'features.entities.geo_arc.session.too_many_vias' | translate }}</span>
    </p>
  } @else if (problem() === 'too-few-points') {
    <p class="flex items-start gap-1.5 text-xs text-red-600 dark:text-red-400">
      <i [class]="ICONS.warningCircle" class="mt-px"></i>
      <span>{{ 'form.error.polylineTooFewPoints' | translate }}</span>
    </p>
  } @else if (problem() === 'endpoints-too-far') {
    <p class="flex items-start gap-1.5 text-xs text-red-600 dark:text-red-400">
      <i [class]="ICONS.warningCircle" class="mt-px"></i>
      <span>{{ 'form.error.polylineEndpointsTooFar' | translate }}</span>
    </p>
  } @else if (hasGeometry()) {
    <p class="text-text-tertiary font-mono text-xs">
      {{
        'features.entities.geo_arc.session.readout'
          | translate: { points: pointCount(), length: lengthKm() }
      }}
    </p>
  }

  <div class="flex items-center justify-between gap-2">
    <button
      type="button"
      class="btn-transparent px-2 py-1 text-xs"
      [disabled]="!hasGeometry() || session.isComputing()"
      [class.btn-disabled]="!hasGeometry() || session.isComputing()"
      (click)="onClear()">
      <i [class]="ICONS.eraser" class="mr-1"></i>
      {{ 'common.clear' | translate }}
    </button>

    <div class="flex items-center gap-2">
      <!--
        Never disabled, not even mid-request: discarding writes nothing back, and the
        session ignores a result that arrives after it ended. Blocking it would strand the
        user in the panel for as long as a stalled provider request takes to settle.
      -->
      <button type="button" class="btn-cancel px-2.5 py-1 text-xs" (click)="onDiscard()">
        {{ 'features.entities.geo_arc.session.discard' | translate }}
      </button>
      <button
        type="button"
        class="btn-primary px-2.5 py-1 text-xs"
        [disabled]="!canCommit()"
        [class.btn-disabled]="!canCommit()"
        (click)="onDone()">
        <i [class]="ICONS.check" class="mr-1"></i>
        {{ 'features.entities.geo_arc.session.done' | translate }}
      </button>
    </div>
  </div>
</section>
